// src/components/LoadingScreen.js
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function LoadingScreen({ message = "Loading..." }) {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
        >
            <CircularProgress />
            <Typography variant="h6" sx={{ mt: 6, mb: 6 }}>
                {message}
            </Typography>
        </Box>
    );
}
